import { Form, type FormInstance } from 'antd'
import { match } from 'ts-pattern'
import { useLingui } from '@lingui/react/macro'

import ReferenceMusicCard from './_components/ReferenceMusicCard'

import type {
  MusicGeneratorFormValuesNew,
  TaskType,
} from '@/pages/tad.ai/ai-music-generator/_types/form'


import { cls } from 'tagged-classnames-free';
interface ReferenceFormProps {
  form: FormInstance<MusicGeneratorFormValuesNew>
}
function ReferenceForm(props: ReferenceFormProps) {
  const customTaskType = (Form.useWatch('customTaskType') as TaskType) || 'Song'
  const { t } = useLingui()
  return (
    <div>
      <div className={cls`space-y-3 pb-8`}>
        <Form.Item noStyle dependencies={['customTaskType']}>
          {(form) => {
            return match(customTaskType)
              .with('Instrumental', () => (
                <ReferenceMusicCard
                  musicType='Instrumental'
                  title={t`Reference instrumental`}
                  form={form}
                />
              ))
              .otherwise(() => (
                <>
                  <ReferenceMusicCard
                    musicType='Song'
                    title={t`Reference song`}
                    form={form}
                  />
                  <ReferenceMusicCard
                    musicType='Vocal'
                    title={t`Reference vocal`}
                    form={form}
                  />
                </>
              ))
          }}
        </Form.Item>
      </div>
    </div>
  )
}

export default ReferenceForm
